import React, { useContext, useState, createContext } from 'react';

export const OpenMinicartContext = createContext();

const OpenMinicartContextProvider = ({ children }) => {
	const [isOpen, setIsOpen] = useState(window?.location?.hash.includes('minicart') ? true : false);
	React.useEffect(() => {
		if (window?.location?.hash.includes('minicart')) {
			setIsOpen(true);
		} else {
			setIsOpen(false);
		}
	}, [window?.location?.hash]);

	return <OpenMinicartContext.Provider value={{ isOpen, setIsOpen }}>{children}</OpenMinicartContext.Provider>;
};

export const useOpenMinicartContextProvider = () => {
	const context = useContext(OpenMinicartContext);

	return context;
};

export default OpenMinicartContextProvider;
